import { Shell } from '../ui/PwaContent';

export function InternalView() {
  return (
    <Shell title="Intern" subtitle="Wachdienste, Anmeldungen, Abstimmungen und interne Informationen.">
      <div className="grid gap-4 md:grid-cols-2">
        <section className="wwpwa-panel"><h2 className="font-bold">Wachdienste</h2><p className="mt-2 text-sm text-gray-600">Platzhalter für Dienstanmeldungen.</p></section>
        <section className="wwpwa-panel"><h2 className="font-bold">Benachrichtigungen</h2><p className="mt-2 text-sm text-gray-600">Später: Web Push und Erinnerungen.</p></section>
      </div>
    </Shell>
  );
}
